import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Menu } from 'semantic-ui-react';
import { Translate } from 'react-redux-i18n';
import * as accountSettingsActions from './reducer';
import { withRouterV6 } from '../../../helpers/withRouterV6.jsx';
import { bindActionCreators } from 'redux';
import { settingsMenuItems, i18nKeys } from '../constants';
import {
  isSystemOwner as checkIsSystemOwner,
  hasSystemOwnerMembership,
  hasSystemMembership
} from '../../../modules/session';
import get from 'lodash.get';
import {
  SystemOnlyIcon,
  SystemOnlyPopup
} from '../../../components/common/SystemOnlyBadge';

class VerticalMenu extends Component {
  state = { activeItem: settingsMenuItems.ACCOUNT_DETAILS };

  handleItemClick = (e, { name }) => {
    this.props.menuItemClick(name);
  };

  render() {
    const { ACCOUNT_DETAILS, UPDATE_PASSWORD, EYES_ONLY, ACCOUNT_SECURITY, EMAIL_NOTIFICATIONS } =
      settingsMenuItems;
    const showSecurityTab =
      !this.props.impersonated &&
      this.props.accountId.toString() === this.props.match.params.id;

    return (
      <Menu vertical fluid>
        <Menu.Item
          name={ACCOUNT_DETAILS}
          active={this.props.activeItem === ACCOUNT_DETAILS}
          as="a"
          onClick={this.handleItemClick}
        >
          <Translate value={i18nKeys.ACCOUNT_DETAILS_ITEM} />
        </Menu.Item>
        {this.props.showUpdatePassword && (
          <Menu.Item
            name={UPDATE_PASSWORD}
            active={this.props.activeItem === UPDATE_PASSWORD}
            as="a"
            onClick={this.handleItemClick}
          >
            <Translate
              value={i18nKeys.UPDATE_PASSWORD_ITEM}
              onClick={this.handleItemClick}
            />
          </Menu.Item>
        )}
        {showSecurityTab && (
          <Menu.Item
            name={ACCOUNT_SECURITY}
            active={this.props.activeItem === ACCOUNT_SECURITY}
            as="a"
            onClick={this.handleItemClick}
          >
            <Translate
              value={i18nKeys.ACCOUNT_SECURITY_ITEM}
              onClick={this.handleItemClick}
            />
          </Menu.Item>
        )}
        {(this.props.isOrgAdmin || this.props.isAccountCampaignAdmin || this.props.isAccountCampaignOrganizerAdmin) && (
          <Menu.Item
            name={EMAIL_NOTIFICATIONS}
            active={this.props.activeItem === EMAIL_NOTIFICATIONS}
            as="a"
            onClick={this.handleItemClick}
          >
            <Translate
              value={i18nKeys.EMAIL_NOTIFICATIONS_ITEM}
              onClick={this.handleItemClick}
            />
          </Menu.Item>
        )}
        {this.props.showEyesOnly && (
          <SystemOnlyPopup>
            <Menu.Item
              name={EYES_ONLY}
              active={this.props.activeItem === EYES_ONLY}
              as="a"
              onClick={this.handleItemClick}
            >
              <Translate
                value={i18nKeys.EYES_ONLY_ITEM}
                onClick={this.handleItemClick}
              />
              <SystemOnlyIcon />
            </Menu.Item>
          </SystemOnlyPopup>
        )}
      </Menu>
    );
  }
}

const mapState = ({ accountSettings, session }) => {
  const activeItem = accountSettings.activeItem;
  const account = accountSettings.record.data.data;
  const isCurrentUserSystemOwner = checkIsSystemOwner(session);
  const isAccountSystemOwner = hasSystemOwnerMembership(account.adminMemberships);
  const viewerAccountId = get(session, 'account.id');
  const isOwnAccount =
    viewerAccountId != null &&
    account.id != null &&
    viewerAccountId.toString() === account.id.toString();

  return {
    activeItem,
    accountId: get(session, 'account.id'),
    // Whoever sets a password knows it, so the API allows setting a system account's password
    // only for a system owner or the account itself. Hiding the tab keeps the UI from offering
    // a save that comes back denied.
    showUpdatePassword:
      !hasSystemMembership(account.adminMemberships) ||
      isOwnAccount ||
      isCurrentUserSystemOwner,
    isOrgAdmin: account.isOrgAdmin,
    impersonated: get(session, 'impersonated'),
    isSystemAdmin: get(session, 'isSystemAdmin'),
    // Show Eyes Only tab if:
    // - Current user is system admin AND account is not a system admin, OR
    // - Current user is a system owner AND account is not a system owner
    showEyesOnly: get(session, 'isSystemAdmin') && (
      !account.isSysAdmin || (isCurrentUserSystemOwner && !isAccountSystemOwner)
    ),
    isAccountCampaignAdmin: get(
      accountSettings,
      'record.data.data.isCampaignAdmin'
    ),
    isAccountCampaignOrganizerAdmin: get(
      accountSettings,
      'record.data.data.isCampaignOrganizerAdmin'
    )
  };
};

const mapDispatch = (dispatch) => {
  return bindActionCreators(accountSettingsActions, dispatch);
};

export default withRouterV6(connect(mapState, mapDispatch)(VerticalMenu));
